import { DataContext } from 'entries/common/widgets/context';
import { Counter, Price, Typography } from 'fronton-react';
import { SMALL_FALLBACK_PRODUCT_IMAGE_URL } from 'pages/common/components/Product/fallback-product-images.const';
import React, { ChangeEvent, useContext, useEffect, useRef } from 'react';
import { useCalculationState } from 'pages/calculation/store/calculation';
import { gaImpressionsProduct } from 'ga-events/ga-impressions-product';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { ProductArticle } from '../ProductArticle';
import { getImageSize } from '../helpers';
import {
  CounterAndPriceContainer,
  MainProductBlock,
  MainProductContainer,
  MainProductImageAndName,
  PriceColumnContainer,
  MainProductName,
  MainProductInfo,
  MainProductInfoRow,
  MainProductInfoColumn,
} from './styles';

export const MainProductComponent = () => {
  const { mobile } = useBreakpoints() ?? {};
  const productRef = useRef<HTMLDivElement>(null);
  const data = useContext(DataContext);
  const imageSize = getImageSize(mobile);
  const { calculationFormState, setCalculationState, calculatedPrice } = useCalculationState();
  const pricePerOneItem = (calculatedPrice / Number(calculationFormState.count)).toFixed(2);
  const handleChangeCounter = (_event: ChangeEvent<HTMLInputElement>, value: string): void => {
    setCalculationState(prevState => ({
      ...prevState,
      count: value,
    }));
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          gaImpressionsProduct({
            name: data?.displayedName ?? '',
            id: data?.productId ?? '',
            price: `${data?.mainPrice ?? 0}`,
            position: '1',
          });
        }
      },

      {
        threshold: 0.5,
      }
    );

    if (productRef.current) {
      observer.observe(productRef.current);
    }

    return () => {
      if (productRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(productRef.current);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps -- Нужно послать только один раз
  }, []);

  return (
    <MainProductBlock ref={productRef}>
      <Typography variant="h3">Основной товар</Typography>
      <MainProductContainer>
        <MainProductImageAndName>
          <img
            src={data?.photo || SMALL_FALLBACK_PRODUCT_IMAGE_URL}
            alt={data?.displayedName}
            loading="lazy"
            width={imageSize}
            height={imageSize}
          />
          <MainProductInfoColumn>
            <MainProductInfoRow>
              <MainProductName>
                <MainProductInfo>
                  <ProductArticle productId={data?.productId} />
                </MainProductInfo>
                <Typography variant="m" size="body_long" color="text-primary">
                  {data?.displayedName}
                </Typography>
              </MainProductName>
              <PriceColumnContainer>
                <Price value={calculatedPrice} fraction variant="medium" align="right" size="l" units="₽" />
                {Number(calculationFormState.count) > 1 ? (
                  <>
                    <Price
                      align="right"
                      fraction
                      size="xs"
                      units="₽ / шт."
                      value={Number(pricePerOneItem)}
                      variant="medium"
                    />
                  </>
                ) : null}
              </PriceColumnContainer>
            </MainProductInfoRow>

            <CounterAndPriceContainer>
              <div>
                <Counter
                  size="s"
                  min={1}
                  value={calculationFormState.count}
                  onChange={handleChangeCounter}
                />
              </div>
            </CounterAndPriceContainer>
          </MainProductInfoColumn>
        </MainProductImageAndName>
      </MainProductContainer>
    </MainProductBlock>
  );
};
